<template lang="pug">
  .login-sso

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { mapActions } from 'vuex'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  methods: mapActions([
    'loginSSO'
  ])
})
export default class Login extends Vue {
  token = ''
  tenantId = ''

  created () {
    this.token = this.$route.query.token
    this.tenantId = this.$route.query.tenant

    if (!this.token) {
      return
    }

    const params = {
      token: this.token,
      tenantId: this.tenantId,
    }

    this.loginSSO(params)
      .then(res => {
        if (res === false) {
          this.gotoRoute('tenant')
        } else {
          this.gotoRoute('home')
        }
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
  }
}
</script>

<style scoped>
.login-form {
  margin-top: 150px;
  max-width: 450px;
  width: 100%;
}
</style>
